import session from './session';
import live from './live';
import ticker from './ticker';
import prematch from './prematch';
import filters from './filters';
import subscription from './subscription';
import users from './users';
import admins from './admins';
import social from './social';
import data from './data';
import profiles from './profiles';
import forecast from './forecast';
import app from './app';
import company from './company';
import ads from './ads';

export default {
  ...app,
  ...session,
  ...live,
  ...ticker,
  ...prematch,
  ...filters,
  ...subscription,
  ...users,
  ...admins,
  ...social,
  ...data,
  ...profiles,
  ...forecast,
  ...company,
  ...ads,
  isLoading(state, { key, status }) {
    const index = state.loadList.findIndex((l) => l === key);
    if (status) {
      if (index < 0) state.loadList.push(key);
    } else {
      if (index >= 0) state.loadList.splice(index, 1);
    }
  },
};
